import React, { useEffect, useState, Fragment } from 'react'
import { Button, Container, Tab, Tabs } from 'react-bootstrap'

import { useDispatch, useSelector } from 'react-redux'
import Conductor from '../Conductor'
import Implicado from '../Implicado'
import Propietario from '../Propietario'

const TabsModal = ({ formik, setRutConductorFinal,setRutPropietarioFinal,setPaisImplicadoFinal }) => {
  const [key, setKey] = useState('implicado')
  const [tipoPerdida, setTipoPerdida] = useState('')

  // El hook useSelector (redux) permite acceder al state en nuestro store.
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const {
    datosPantalla,
    comboSeguro,
    comboCompanias,
    comboVehiculos,
    comboMarcas
  } = data_datos_implicado
  const { antecedentesCasos, cfg_form_implicado } = data_datos_generales
  const dispatch = useDispatch()

  useEffect(() => {
    if (
      antecedentesCasos &&
      antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro'] === 15005
    ) {
      setTipoPerdida('Parcial')
    } else {
      setTipoPerdida('Total')
    }
  }, [antecedentesCasos])

  return (
    <>
      <style type='text/css'>
        {`
          .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
          color: white;
          background-color: #01CECA;
          
          }

          .nav-tabs {
              border-Bottom: 1px solid #253B6D;
             
          }
          .nav-item{
           
   
            color: #d9d9d9;
            border: 1px solid #01CECA;
            border-radius:5px 5px 0px 0px;  
            margin-right:2px;
         
            border-Bottom:none;            
            
          }
          .nav-tabs .nav-link:hover{
            color:white;
              background-color: #01CECA;
             
              
          }
     `}
      </style>
      <Container>
        <Container>
          <Tabs
            className='nav-tabs'
            activeKey={key}
            id='uncontrolled-tab-example'
            onSelect={(k) => {
              setKey(k)
              
            }}
          >
            <Tab.Pane
              eventKey='implicado'
              title={
                cfg_form_implicado
                  ? cfg_form_implicado.cfg_form_implicado[
                      'gestcasosrecup-tab-documentacion-chkimpl'
                    ]
                  : null
              }
            >
              <Implicado
                formik={formik}
               
                setPaisImplicadoFinal={setPaisImplicadoFinal}
              />
            </Tab.Pane>
            <Tab.Pane
              eventKey='conductor'
              title={
                cfg_form_implicado
                  ? cfg_form_implicado.cfg_form_implicado[
                      'gestcasosrecup-editimpl-title-tabcond'
                    ]
                  : null
              }
            >
              <Conductor
                formik={formik}
                setRutConductorFinal={setRutConductorFinal}
              />
            </Tab.Pane>
            <Tab.Pane
              eventKey='propietario'
              title={
                cfg_form_implicado
                  ? cfg_form_implicado.cfg_form_implicado[
                      'gestcasosrecup-editimpl-title-tabprop'
                    ]
                  : null
              }
            >
              <Propietario formik={formik} setRutPropietarioFinal={setRutPropietarioFinal} />
            </Tab.Pane>
          </Tabs>
        </Container>
      </Container>
    </>
  )
}

export default TabsModal
